import { useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { useCritterStore } from '../store/critterStore'
import useSettingsStore from '../store/settingsStore'
import { useTwitchConnection } from '../hooks/useTwitchConnection'
import CritterContainer from '../components/CritterContainer'
import StatusDisplay from '../components/StatusDisplay'
import AuthPrompt from '../components/AuthPrompt'
import SettingsPanel from '../components/SettingsPanel'
import Settings3DPanel from '../components/Settings3DPanel'
import '../styles/App.css'

function Overlay() {
  const { broadcasterLogin } = useParams()
  const { status, needsAuth, authUrl, connect, openAuthPopup } = useTwitchConnection(broadcasterLogin)
  const loadCritters = useCritterStore((state) => state.loadFromApi)
  const loadCritterTypes = useCritterStore((state) => state.loadCritterTypes)
  const setBroadcasterLogin = useCritterStore((state) => state.setBroadcasterLogin)
  const loadSettings = useSettingsStore((state) => state.loadFromApi)
  const setSettingsBroadcaster = useSettingsStore((state) => state.setBroadcasterLogin)
  const staticMode = useSettingsStore((state) => state.settings.staticMode)
  const enableSleepMode = useSettingsStore((state) => state.settings.enableSleepMode)
  const prevStaticMode = useRef(staticMode)
  const prevSleepMode = useRef(enableSleepMode)

  useEffect(() => {
    if (broadcasterLogin) {
      // Set broadcaster context in stores
      setBroadcasterLogin(broadcasterLogin)
      setSettingsBroadcaster(broadcasterLogin)
      // Load critter types, critters, and settings from database
      loadCritterTypes()
      loadCritters(broadcasterLogin)
      loadSettings(broadcasterLogin)
      // Connect to Twitch
      connect()

      // Start sleep check if sleep mode is enabled
      const settings = useSettingsStore.getState().settings
      if (settings.enableSleepMode) {
        useCritterStore.getState().startSleepCheck()
      }
    }
  }, [broadcasterLogin, loadCritters, loadCritterTypes, setBroadcasterLogin, loadSettings, setSettingsBroadcaster, connect])

  // Handle static mode changes - stop or restart roaming (only when staticMode actually changes)
  useEffect(() => {
    if (prevStaticMode.current !== staticMode) {
      prevStaticMode.current = staticMode
      const { startRoaming, stopRoaming, critters } = useCritterStore.getState()
      const hasCritters = Object.keys(critters).length > 0
      if (hasCritters) {
        if (staticMode) {
          stopRoaming()
        } else {
          startRoaming()
        }
      }
    }
  }, [staticMode])

  // Handle sleep mode changes
  useEffect(() => {
    if (prevSleepMode.current !== enableSleepMode) {
      prevSleepMode.current = enableSleepMode
      const { startSleepCheck, stopSleepCheck, wakeAllCritters } = useCritterStore.getState()
      if (enableSleepMode) {
        startSleepCheck()
      } else {
        stopSleepCheck()
        wakeAllCritters()
      }
    }
  }, [enableSleepMode])

  if (!broadcasterLogin) {
    return (
      <div className="overlay" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
        <p>Missing broadcaster login in URL</p>
      </div>
    )
  }

  return (
    <div className="overlay">
      <CritterContainer />
      {needsAuth && <AuthPrompt authUrl={authUrl} onAuth={openAuthPopup} />}
      <StatusDisplay status={status} needsAuth={needsAuth} />
      <SettingsPanel isAdmin={true} broadcasterLogin={broadcasterLogin} />
      <Settings3DPanel isAdmin={true} broadcasterLogin={broadcasterLogin} />
    </div>
  )
}

export default Overlay
